import React from 'react';
import { selectImagesAccordingToBank } from './utilities';
import {
  DESKTOPIMAGETYPE1,
  DESKTOPIMAGETYPE2,
  MOBILEVIEWIMAGETYPE,
} from './constants';

interface Iprops {
  bankName: string;
  imageType?: string;
  className?: string;
}

export const ImageSelectorComponent = (props: Iprops) => {
  const { bankName, imageType, className } = props;

  const imageLinksObject = selectImagesAccordingToBank(bankName);
  let linkToBeUsed;
  switch (imageType) {
    case DESKTOPIMAGETYPE1:
      linkToBeUsed = imageLinksObject.image1Link;
      break;
    case DESKTOPIMAGETYPE2:
      linkToBeUsed = imageLinksObject.image2Link;
      break;
    case MOBILEVIEWIMAGETYPE:
      linkToBeUsed = imageLinksObject.imageMobileViewLink;
      break;
    default:
      break;
  }
  return <img className={className} src={linkToBeUsed} alt="" />;
};
